import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ChipInput from 'material-ui-chip-input'
import CustomSelect from "../Select";
import {Grid, Typography} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {removeItemFromArray, superSplit} from "../../utils/functions";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";
import Info from '@material-ui/icons/Info';
import Tooltip from "@material-ui/core/Tooltip";
import {getPaymentData} from "../../services/authService";
import {PAYMENT_ROUTES} from "../../config/routes";


const Theme = (borderRadius = '0 0 0 0') => createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: borderRadius,
            },
            input: {
                padding: '10px 14px',
            }
        },
        MuiInputLabel: {
            formControl: {
                top: '-12px',
                left: '10px'
            }
        },
        MuiDialogActions: {
            root: {
                justifyContent: 'center'
            }
        },
        MuiButton: {
            root: {
                borderRadius: borderRadius,
            },
            containedPrimary: {
                color: '#fff'
            },
            contained: {
                color: '#7a865d'
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },


    },
});

class PaymentAmountPopup extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            amount: null
        }
        
        this.handleClose = () => {
            this.props.onClose();
        };
        this.handleChange = (text) => {
            this.setState({amount: text.replace(/\D/g, '')});
        };

        
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.open !== this.props.open) {
            this.forceUpdate();
        }
    }

    render() {
        

        return (
            <div style={{}}>
                <Dialog open={this.props.open} onClose={this.handleClose} aria-labelledby="form-dialog-title"
                        style={{textAlign: "center"}}>
                    <DialogTitle style={{backgroundColor: '#f9f9f9'}} id="form-dialog-title"><b>Введите сумму пополнения</b></DialogTitle>
                    <ThemeProvider theme={Theme('34px' || '0 0 0 0')}>
                        <DialogContent style={{textAlign: "center", marginBottom: '30px', }}>
                            <TextField
                                style={{width: '80%', textAlign: 'center'}}
                                value={this.state.amount} 
                                onChange={e => this.handleChange(e.target.value)}
                                inputProps={{ maxLength: 20, style: {textAlign: 'center'} }}
                            />

                                
                            </DialogContent>
                        <DialogActions style={{marginBottom: '20px'}}>
                            <form hidden={true} id={'form'} method="post" action="https://secure.wayforpay.com/pay"
                                  accept-charset="utf-8">
                                <input id={"merchantAccount"} name="merchantAccount" value="test_merch_n1"/>
                                <input name="merchantAuthType" value="SimpleSignature"/>
                                <input id="merchantDomainName" name="merchantDomainName" value="www.market.ua"/>
                                <input id="clientPhone" name="clientPhone" value=""/>
                                <input id="merchantSignature" name="merchantSignature"
                                       value="e0f136cb3a85f92894fe8bb73ae540d0"/>
                                <input id="orderReference" name="orderReference" value="DH78302346789"/>
                                <input id="orderDate" name="orderDate" value="1415379863"/>
                                <input id="amount" name="amount" value="1547.36"/>
                                <input name="currency" value="UAH"/>
                                <input name="orderTimeout" value="49000"/>
                                <input name="productName[]" value="Поповнення рахунку Help-Chat"/>
                                <input id={"productPrice"} name="productPrice[]" value="1000"/>
                                <input name="productCount[]" value="1"/>
                                <input id="clientFirstName" name="clientFirstName" value="Вася"/>
                                <input id="clientLastName" name="clientLastName" value="Пупкин"/>
                                <input id="clientEmail" name="clientEmail" value="some@mail.com"/>
                                <input id="returnUrl" name="returnUrl" value={PAYMENT_ROUTES.returnUrl}/>
                                {/*<input id="serviceUrl" name="serviceUrl" value={PAYMENT_ROUTES.returnUrl}/>*/}
                                <input id="serviceUrl" name="serviceUrl"
                                       value={PAYMENT_ROUTES.callbackWayForPay}/>
                                <input name="defaultPaymentSystem" value="card"/>
                                <button hidden={true} type="submit">Оплатить</button>
                            </form>
                            <Button variant={'contained'} onClick={this.handleClose} color="default">
                                Отмена
                            </Button>
                            <Button variant={'contained'} onClick={async () => {
                                let data = (await getPaymentData(this.state.amount)).data;
                                window.document.getElementById('merchantAccount').value = data.merchantAccount
                                window.document.getElementById('merchantDomainName').value = data.merchantDomainName
                                window.document.getElementById('merchantSignature').value = data.merchantSignature
                                window.document.getElementById('orderReference').value = data.orderReference
                                window.document.getElementById('orderDate').value = data.orderDate
                                window.document.getElementById('amount').value = data.amount
                                window.document.getElementById('productPrice').value = data.amount
                                window.document.getElementById('clientFirstName').value = data.clientFirstName
                                window.document.getElementById('clientLastName').value = data.clientLastName
                                window.document.getElementById('merchantAccount').value = data.merchantAccount
                                window.document.getElementById('clientEmail').value = data.clientEmail
                                window.document.getElementById('clientPhone').value = data.clientPhone
                                window.document.getElementById('form').submit()
                            }} color="primary">
                                Пополнить
                            </Button>
                        </DialogActions>
                    </ThemeProvider>
                </Dialog>
            </div>
        );
    }
}

export default PaymentAmountPopup